<template>
  <avtalat-input
    id="telefonnummer"
    v-model:value="telefonnummer"
    :label="label"
  />
  <FormErrorMessage name="telefonnummer" />
</template>

<script setup lang="ts">
import FormErrorMessage from "../ui/FormErrorMessage.vue";

defineProps<{
  label: string;
}>();

const telefonnummer = defineModel<string>();
</script>
